import IcFacebook from './IcFacebook'
export default IcFacebook
